@if (prelim) {
  <div [innerHTML]="prelim"></div>
}
@if (text) {
  <div>
      <span [innerHTML]="text"></span>
      <ng-content></ng-content>
  </div>
}
@if (lsData.rightScale && lsData.leftScale) {
  <div class="extreme-scales">
    <p>{{lsData.leftScale}}</p>
    <p>{{lsData.rightScale}}</p>
  </div>
}
<div class="graphic-box"></div>